/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

export function bValidCpf(strCPF: string) {
  let Soma;
  let Resto;

  // Remove caracteres não numéricos
  strCPF = strCPF.replace(/\D/g, "");

  // Verifica se tem 11 dígitos
  if (strCPF.length !== 11) return false;

  // Descarta CPFs de todos os dígitos iguais
  if (/^(\d)\1+$/.test(strCPF)) return false;

  Soma = 0;
  for (let i = 1; i <= 9; i++) {
    Soma += parseInt(strCPF.substring(i - 1, i)) * (11 - i);
  }
  Resto = (Soma * 10) % 11;

  if (Resto === 10 || Resto === 11) Resto = 0;
  if (Resto !== parseInt(strCPF.substring(9, 10))) return false;

  Soma = 0;
  for (let i = 1; i <= 10; i++) {
    Soma += parseInt(strCPF.substring(i - 1, i)) * (12 - i);
  }
  Resto = (Soma * 10) % 11;

  if (Resto === 10 || Resto === 11) Resto = 0;
  if (Resto !== parseInt(strCPF.substring(10, 11))) return false;

  return true;
}
